// The callback an outbound leg was dialled FOR (2026-09-23, #20).
//
// Two sources, merged: the contact's own attributes (callbackId /
// originalContactId, stamped by knktr-outbound-context at bind — survive a
// reload and reach history) and the dial context the console handed over
// when the agent pressed Call customer / Call now (the task's or row's own
// handover: AI summary of the originating call, reason, window). Attributes
// win for the ids; the dial context is the only source of the rich context.
// Returns null when this leg is not for a callback. Pure, so
// scripts/verify-outbound-callback-context.mjs can drive it.
const str = v => { const s = String(v ?? '').trim(); return s || null; };

export function callbackOriginFrom({ attrs = {}, dialCtx = null } = {}) {
  const a = k => str(attrs?.[k]?.value ?? attrs?.[k]);
  const h = dialCtx?.handover || {};
  const callbackId = a('callbackId') ?? str(dialCtx?.callbackId);
  if (!callbackId) return null;
  const originalContactId = a('originalContactId') ?? str(dialCtx?.originalContactId);
  return {
    callbackId,
    originalContactId,
    source: a('callbackId') ? 'attributes' : 'dial-context',
    reason: str(h.reason),
    aiSummary: str(h.aiSummary),
    window: str(h.window),
    callerNumber: str(h.callerNumber),
    taskContactId: str(h.taskContactId),
  };
}

// Is this pending dial context the one that prepared THIS contact? The prepare
// returns a requestId and the whisper flow writes it on the contact as
// outboundContextId; only that contact may read the context (review
// 2026-09-23: a stale ref from an earlier dial must never reach another
// customer's call). No requestId on the ref (an old bundle's shape) -> never.
export function dialContextMatches(ref, attrs) {
  const want = str(ref?.requestId);
  const got = str(attrs?.outboundContextId?.value ?? attrs?.outboundContextId);
  return Boolean(want && got && want === got);
}
